import { useEffect } from "react";

export function usePageTitle(title) {
  useEffect(() => {
    document.title = title || "SISMS GRC";
    
    // Cleanup function to reset title when component unmounts
    return () => {
      document.title = "SISMS GRC";
    };
  }, [title]);
}
